import { randomId } from '../../shared/ids';

function attempt<T>(fn: () => T, fallback: T): T {
  try {
    return fn();
  } catch {
    return fallback;
  }
}

let memoryClientId: string | null = null;

export const storage = {
  /** Sekme başına kimlik: aynı tarayıcıda öğretmen ve öğrenci sekmesi ayrı katılımcı olur; yenilemede korunur. */
  clientId(): string {
    const fromSession = attempt(() => sessionStorage.getItem('nova.clientId'), null);
    if (fromSession) return fromSession;
    memoryClientId ??= randomId(16);
    attempt(() => sessionStorage.setItem('nova.clientId', memoryClientId!), undefined);
    return memoryClientId;
  },
  name(): string {
    return attempt(() => localStorage.getItem('nova.name') ?? '', '');
  },
  setName(name: string) {
    attempt(() => localStorage.setItem('nova.name', name), undefined);
  },
  /** Bu sekmede derse girilmişse, sayfa yenilenince giriş ekranı atlanır. */
  joinedAs(lessonId: string): string | null {
    return attempt(() => sessionStorage.getItem(`nova.joined.${lessonId}`), null);
  },
  markJoined(lessonId: string, name: string) {
    attempt(() => sessionStorage.setItem(`nova.joined.${lessonId}`, name), undefined);
  },
};

export const studentLink = (id: string) => `${location.origin}/ders/${id}`;
export const teacherLink = (id: string, key: string) => `${location.origin}/ders/${id}?ogretmen=${encodeURIComponent(key)}`;
